import { LoadingWheel } from '../base/LoadingWheel';

export function FullscreenLoading() {
  return (
    <div className="h-screen w-screen flex items-center justify-center bg-white/80 dark:bg-gray-900/80">
      <LoadingWheel color="netural" className="w-20 h-20" />
    </div>
  );
}
